import { createFileRoute } from '@tanstack/react-router';

import CreateRole from '@/modules/settings/pages/CreateRole';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/roles/new',
)({
  head: () => ({
    meta: [{ title: 'Criar Nova Função' }],
  }),
  component: CreateRole,
});
